import { animate, scroll } from "motion";

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    const headerLogo = header.querySelector(".header__logo");
    const headerButtons = header.querySelector(".header__buttons");
    const menuButton = header.querySelector(".header__menu-button");

    scroll(
        animate([headerLogo, headerButtons], {
            y: [0, -(header.offsetTop + header.offsetHeight)],
        }),
        {
            target: header,
            offset: ["start 24px", "end start"],
        },
    );

    const handleMenuToggle = async () => {
        header.classList.toggle("header--open");
        const label = menuButton.querySelector("span");
        const icon = menuButton.querySelector("svg > path");
        const d = header.classList.contains("header--open")
            ? icon.getAttribute("data-path-close")
            : icon.getAttribute("data-path-open");

        await animate(icon, {
            d,
            duration: 640,
            ease: "easeInOut",
        });

        label.innerHTML = header.classList.contains("header--open")
            ? label.getAttribute("data-label-close")
            : label.getAttribute("data-label-open");
    };

    menuButton.addEventListener("click", handleMenuToggle);

    const mediaQuery = window.matchMedia("(max-width: 1024px)");
    const handleMatchMediaChange = (e) => {
        if (!e.matches && header.classList.contains("header--open")) {
            handleMenuToggle();
        }
    };

    mediaQuery.addEventListener("change", handleMatchMediaChange);

    handleMatchMediaChange(mediaQuery);

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute("id");

                    links.forEach((link) => {
                        link.removeAttribute("aria-current");
                        if (link.getAttribute("href") === "#" + id) {
                            link.setAttribute("aria-current", "location");
                        }
                    });
                }
            });
        },
        {
            root: null,
            rootMargin: "200px",
            threshold: 0.1,
        },
    );

    const links = header.querySelectorAll('.header__nav a[href^="#"]:not([href="#"])');

    links.forEach((link) => {
        const hash = link.getAttribute("href");
        const section = document.querySelector(hash);

        if (!section) return;

        observer.observe(section);

        if (hash === window.location.hash) {
            link.setAttribute("aria-current", "location");
        }

        link.addEventListener("click", function (e) {
            e.preventDefault();
            if (header.classList.contains("header--open")) {
                handleMenuToggle();
            }
            section.scrollIntoView({ behavior: "smooth" });

            links.forEach((l) => l.removeAttribute("aria-current"));
            links.forEach((l) => {
                if (l.getAttribute("href") === hash) {
                    l.setAttribute("aria-current", "location");
                }
            });

            history.pushState(null, "", hash);
        });
    });

    // Handle Weglot dropdown with our own class - take full control
    const handleWeglotActiveState = () => {
        const weglotWrapper = document.querySelector(".weglot-wrapper");
        const weglotDropdown = document.querySelector(".country-selector.weglot-dropdown");

        if (weglotWrapper && weglotDropdown) {
            const weglotCurrent = weglotDropdown.querySelector(".wgcurrent");
            const weglotCheckbox = weglotDropdown.querySelector('input[type="checkbox"]');

            const closeWeglotDropdown = () => {
                if (weglotCheckbox) weglotCheckbox.checked = false;
                weglotWrapper.classList.remove("active");
                weglotDropdown.classList.add("closed");
                weglotDropdown.setAttribute("aria-expanded", "false");
            };

            if (weglotCurrent) {
                // Let Weglot handle the dropdown, but sync our class and aria state
                weglotCurrent.addEventListener("click", () => {
                    // Small delay to let Weglot update its classes first
                    setTimeout(() => {
                        const isClosed = weglotDropdown.classList.contains("closed");
                        weglotDropdown.setAttribute("aria-expanded", isClosed ? "false" : "true");
                        if (weglotCheckbox) weglotCheckbox.checked = !isClosed;
                        if (isClosed) {
                            weglotWrapper.classList.remove("active");
                        } else {
                            weglotWrapper.classList.add("active");
                        }
                    }, 10);
                });
            }

            // Handle clicks outside to close dropdown
            document.addEventListener("click", (e) => {
                if (!weglotWrapper.contains(e.target)) {
                    closeWeglotDropdown();
                }
            });

            // Handle language selection clicks using event delegation
            weglotDropdown.addEventListener("click", (e) => {
                // Check if clicked element is a language link
                if (e.target.tagName === "A" && e.target.closest("li")) {
                    // Close dropdown when language is selected
                    setTimeout(() => {
                        closeWeglotDropdown();
                    }, 10);
                }
            });

            // Initialize state based on current Weglot state
            const initialClosed = weglotDropdown.classList.contains("closed");
            if (initialClosed) {
                weglotWrapper.classList.remove("active");
            } else {
                weglotWrapper.classList.add("active");
            }
        } else {
            // Retry if elements not found yet
            setTimeout(handleWeglotActiveState, 100);
        }
    };

    // Initialize Weglot active state handler
    handleWeglotActiveState();
});
